/**
 * Zen Events - Client-side sorting for event cards
 * Sorts upcoming events ascending (soonest first) and past events descending (most recent first)
 * by event start date, since Shopify Liquid can only sort by published_at.
 */
(function() {
  'use strict';

  function sortEventCards(containerSelector, ascending) {
    var container = document.querySelector(containerSelector + ' .zen-blog-events__list');
    if (!container) return;

    var cards = Array.prototype.slice.call(container.querySelectorAll('.zen-event-card'));
    if (cards.length < 2) return;

    cards.sort(function(a, b) {
      var aTs = parseInt(a.getAttribute('data-event-start-ts'), 10) || 0;
      var bTs = parseInt(b.getAttribute('data-event-start-ts'), 10) || 0;
      return ascending ? (aTs - bTs) : (bTs - aTs);
    });

    var fragment = document.createDocumentFragment();
    cards.forEach(function(card) {
      fragment.appendChild(card);
    });
    container.appendChild(fragment);
  }

  // Sort upcoming events ascending (soonest first)
  sortEventCards('#zen-events-upcoming', true);

  // Sort past events descending (most recent first)
  sortEventCards('#zen-events-past', false);
})();
